/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const MeetingStatusDto = {
    Discovered: 'DISCOVERED',
    Scheduled: 'SCHEDULED',
    Joining: 'JOINING',
    InCall: 'IN_CALL',
    Recording: 'RECORDING',
    RecordingDone: 'RECORDING_DONE',
    Transcribing: 'TRANSCRIBING',
    TranscriptReady: 'TRANSCRIPT_READY',
    NoteReady: 'NOTE_READY',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED',
} as const;

export type MeetingStatusDto = typeof MeetingStatusDto[keyof typeof MeetingStatusDto];



